import React, { useEffect } from 'react';
import { WebLayout } from 'components/Layout';
import { Link } from 'react-router-dom';

import ScrumBoardBro from 'assets/scrum-board-bro.svg';
import PairProgrammingBro from 'assets/pair-programming-bro.svg';
import Step1Img from 'assets/step-1.svg';
import Step2Img from 'assets/step-2.svg';
import Step3Img from 'assets/step-3.svg';

import { HeroBanner } from '../components/HeroBanner';

export const Landing = () => {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <WebLayout>
      {/* HERO */}
      <HeroBanner />

      {/* CUSTOMER VOICE */}
      <section className="relative px-6 md:px-32 py-20 text-white bg-black overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(243,199,44,0.1),transparent)]" />

        <div className="relative z-10 text-right">
          <h3 className="text-4xl md:text-6xl font-extrabold mb-5 text-[#F3C72C]">
            Customers Drive Our Innovation
          </h3>

          <h3 className="text-3xl md:text-4xl font-bold mb-5">
            Great systems come from deeper conversations.
          </h3>

          <p className="text-lg text-gray-300 max-w-2xl ml-auto">
            We listen, refine, question assumptions, and co-create software that gives businesses
            operational power.
          </p>
        </div>
      </section>

      {/* APPROACH */}
      <section className="px-6 md:px-32 py-20 grid md:grid-cols-2 items-center gap-14">
        <img src={ScrumBoardBro} alt="Scrum" className="w-full max-w-md mx-auto" />

        <div className="text-right">
          <h3 className="text-4xl md:text-6xl font-extrabold text-[#F3C72C] mb-3">Our Approach</h3>

          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Built with Insight. Delivered with Precision.
          </h3>

          <p className="text-lg text-gray-700 dark:text-gray-300">
            Every solution we build is a balance of design, functionality, performance and long-term
            maintainability.
          </p>
        </div>
      </section>

      {/* TEAM */}
      <section className="px-6 md:px-32 py-20 grid md:grid-cols-2 items-center gap-12">
        <div>
          <h3 className="text-4xl md:text-6xl font-extrabold text-[#F3C72C] mb-3">Our Team</h3>
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Small. Specialized. Globally Connected.
          </h3>

          <p className="text-lg text-gray-700 dark:text-gray-300 mb-6">
            A remote-first team with expertise across UI/UX, backend systems, security, and DevOps.
          </p>

          <Link
            to="/team"
            className="bg-black text-white px-10 py-3 font-bold border border-[#F3C72C] rounded-xl hover:bg-[#F3C72C]/10"
          >
            Meet the Team
          </Link>
        </div>

        <img src={PairProgrammingBro} alt="Team" className="w-full max-w-md mx-auto" />
      </section>

      {/* WORKFLOW */}
      <section className="bg-black text-white px-6 md:px-32 py-24">
        <h3 className="text-4xl md:text-6xl font-extrabold text-[#F3C72C] text-right mb-2">
          Our Workflow
        </h3>
        <h3 className="text-3xl md:text-4xl font-extrabold text-gray-400 text-right mb-12">
          Clarity → Execution → Delivery
        </h3>

        {[Step1Img, Step2Img, Step3Img].map((img, i) => (
          <div
            key={i}
            className={`grid md:grid-cols-2 gap-14 items-center mb-20 ${
              i % 2 !== 0 ? 'flex-row-reverse' : ''
            }`}
          >
            {i % 2 !== 0 && <img src={img} alt="" className="rounded-xl" />}

            <div className={i % 2 !== 0 ? 'text-right' : ''}>
              <div className="uppercase font-bold text-[#F3C72C] mb-2">{`Step 0${i + 1}`}</div>

              <h4 className="text-3xl font-bold mb-4">
                {i === 0 && 'Understanding Your Business First'}
                {i === 1 && 'Design, Development & Iteration'}
                {i === 2 && 'Delivery with Full Access'}
              </h4>

              <p className="text-lg text-white/80">
                {i === 0 &&
                  'We begin by learning your goals, challenges, and workflows to define the right software approach.'}
                {i === 1 &&
                  'Our team handles UI/UX, development, testing, and iteration with full transparency.'}
                {i === 2 &&
                  'We launch and hand over full access to the infrastructure, codebase, designs, and credentials.'}
              </p>
            </div>

            {i % 2 === 0 && <img src={img} alt="" className="rounded-xl" />}
          </div>
        ))}
      </section>

      {/* FINAL CTA */}
      <section className="px-6 md:px-32 py-20 text-center">
        <h3 className="text-4xl md:text-6xl font-extrabold mb-6">
          We transform <span className="text-[#F3C72C]">visionary ideas</span> into real digital
          products.
        </h3>

        <Link
          to="/contact-us"
          className="px-10 py-3 text-white bg-black border border-[#F3C72C] rounded-xl font-bold hover:bg-[#F3C72C]/10"
        >
          Start a Project
        </Link>
      </section>
    </WebLayout>
  );
};
